import React from 'react';
import { useTranslation } from 'react-i18next';

import { WarningIcon } from '~/assets';

import { WarningLine } from './MatchingRulesField.styles';

/** Under a rule without an identifier column, in the form and on the card */
const ProfileOnlyWarning = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <WarningLine>
      <WarningIcon aria-hidden />
      {t('aiInsights.a2ui.matchingRules.profileOnlyWarning')}
    </WarningLine>
  );
};

export default ProfileOnlyWarning;
